import type { FC, PropsWithChildren } from 'react';

import { Tooltip, type TooltipProps } from '../../feedback/Tooltip/Tooltip';

export type ButtonTooltipProps = {
  tooltip?: TooltipProps['title'] | null;
  disabled?: boolean;
  tooltipProps?: Partial<TooltipProps>;
};

export const ButtonMaybeTooltip: FC<PropsWithChildren<ButtonTooltipProps>> = ({
  children,
  tooltip,
  disabled,
  tooltipProps,
}) =>
  tooltip ? (
    <Tooltip title={tooltip} {...tooltipProps}>
      {
        // A disabled button does not fire event, which causes the tooltip not
        // to work; which is why we add an extra wrapping div so the tooltip
        // remain usable even though the wrapped button is disabled.
        disabled ? <div>{children}</div> : children
      }
    </Tooltip>
  ) : (
    children
  );
